<template>
    <div class="card">
        <div class="card-body">
            <loading :active.sync="isLoading"
                     :is-full-page="true"
                     color="green"
                     loader="dots"
            ></loading>
            <form action="#" v-on:submit.prevent="externalSearch(searchQuery)" class="w-100">
                <div>
                    <div class="input-group">
                        <input type="text" name="query" class="form-control input-index" v-model="searchQuery" placeholder="Шукати у зовнішніх каталогах">
                        <div class="input-group-btn">
                            <button type="submit" class="btn btn-link button-index"><img src="/theme/icons/search.svg" width="24px"></button>
                        </div>
                    </div>
                    <div class="row w-100 m-b-20 text-center" style="height:10px">
                        <div class="invalid-feedback">

                        </div>
                    </div>
                </div>
            </form>
            <div class="row" v-if="results.length > 0">
                <table class="table reader table-books">
                    <thead>
                    <tr>
                        <th>
                            Сервер
                        </th>
                        <th>
                            Назва
                        </th>
                        <th>
                            Автор / співавтори
                        </th>
                        <th>
                            Основна рубрика
                        </th>
                        <th>
                            Видання
                        </th>
                        <th>
                            Дії
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in results">
                        <td>
                            {{item.server.name}}
                        </td>

                        <td v-if="typeof item.fields.title !== 'undefined'">
                            <a @click="getModal(item.server.id, item.fields.position)">{{item.fields.title.value}}</a>
                        </td>
                        <td v-else>
                            <a @click="getModal(item.server.id, item.fields.position)">Немає даних</a>
                        </td>

                        <td v-if="typeof item.fields.author !== 'undefined'">
                            {{item.fields.author.value}}
                        </td>
                        <td v-else>
                            Немає даних
                        </td>

                        <td v-if="typeof item.fields.rubric !== 'undefined'">
                            {{item.fields.rubric.value}}
                        </td>
                        <td v-else>
                            Немає даних
                        </td>

                        <td v-if="typeof item.fields.publisher !== 'undefined'">
                            {{item.fields.publisher.value}}
                        </td>
                        <td v-else>
                            Немає даних
                        </td>

                        <td class="text-center">
                            <button @click="importItem(item.server.id, item.fields.position)" class="btn btn-success" style="width: auto;height: auto;">Імпортувати</button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="rows > currentPage" class="ml-auto">
                <div class="m-t-10 p-t-30">
                    <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="my-table"
                            @input="externalSearch(searchQuery)"
                    ></b-pagination>
                </div>
            </div>
        </div>
        <external-search-item :item="item"></external-search-item>
    </div>
</template>

<script>
    import Loading from 'vue-loading-overlay';
    import ExternalSearchItem from "./ExternalSearchItem";

    export default {
        name: "ExternalSearch",
        components:{
            Loading,
            ExternalSearchItem
        },
        props:[],
        mounted() {
            this.searchQuery = this.$route.query.query;
            if (this.searchQuery) {
                this.externalSearch(this.$route.query.query);
            }
        },
        data() {
            return {
                searchQuery:false,
                item: false,
                isLoading:false,
                results:[],
                rows:0,
                perPage:0,
                currentPage:1
            }
        },
        methods:{
            externalSearch(searchQuery) {
                let current = this;
                this.isLoading = true;
                axios.get('/library/external-search/results',{params:{page:this.currentPage,query:searchQuery}}).then(response => {
                    this.isLoading = false;
                    if (response.data.message) {
                        this.results = [];
                        this.rows = 0;
                        this.perPage = 0;
                        $(".invalid-feedback").show();
                        $(".invalid-feedback").html("<span>" + response.data.message + "</span>");
                        $(".invalid-feedback").fadeOut(4000);
                    }
                    if (response.data.results.length !== 0) {
                        this.results = response.data.results;
                        this.rows = response.data.total;
                        this.perPage = response.data.per_page;
                        window.history.replaceState(null, null, "?query=" + searchQuery);
                    }
                }).catch(function(error) {
                    current.isLoading = false;
                    Swal.fire('Виникла помилка', error.message, 'error');
                });
            },

            getModal(serverId, position) {
                let current = this;
                this.isLoading = true;
                axios.get('/library/external-search/get-item',{params:{server_id:serverId,position:position,query:this.searchQuery}}).then(response => {
                    this.isLoading = false;
                    if (response.data.message) {
                        Swal.fire(response.data.message, '', response.data.status);
                    } else {
                        this.item = response.data.item;
                        this.$bvModal.show("ExternalSearchItem");
                    }
                }).catch(function(error) {
                    current.isLoading = false;
                    Swal.fire('Виникла помилка', error.message, 'error');
                });
            },

            importItem(serverId, position) {
                let current = this;
                this.isLoading = true;
                axios.get('/library/external-search/import',{params:{server_id:serverId,position:position,query:this.searchQuery}}).then(response => {
                    this.isLoading = false;
                    let id = response.data.item.id;
                    if (response.data.message) {
                        $(".invalid-feedback").show();
                        $(".invalid-feedback").html("<span>" + response.data.message + "</span>");
                        $(".invalid-feedback").fadeOut(4000);
                    } else {
                        window.open('/library/descriptions/' + id + '/edit', '_blank');
                        Swal.fire('Запис успішно імпортовано!', '', 'success');
                    }
                }).catch(function(error) {
                    current.isLoading = false;
                    Swal.fire('Виникла помилка', error.message, 'error');
                });
            },
            moment: function (date) {
                return moment(date);
            },
        }
    }
</script>

<style scoped>
    .card {
        min-height: 600px;
    }
</style>